import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const ClientIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.50002 3C5.92601 3 4.65002 4.27599 4.65002 5.85C4.65002 7.42401 5.92601 8.7 7.50002 8.7C9.07404 8.7 10.35 7.42401 10.35 5.85C10.35 4.27599 9.07404 3 7.50002 3ZM5.85002 5.85C5.85002 4.93873 6.58875 4.2 7.50002 4.2C8.41129 4.2 9.15002 4.93873 9.15002 5.85C9.15002 6.76127 8.41129 7.5 7.50002 7.5C6.58875 7.5 5.85002 6.76127 5.85002 5.85Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13 13.0001C12.1164 13.0001 11.4 13.7164 11.4 14.6001V19.4C11.4 20.2837 12.1164 21 13 21H19.4C20.2837 21 21 20.2837 21 19.4V14.6001C21 13.7164 20.2837 13.0001 19.4 13.0001H18.5V12.4C18.5 11.5164 17.7837 10.8 16.9 10.8H15.7C14.8164 10.8 14.1 11.5164 14.1 12.4V13.0001H13ZM17.3 12.4V13.0001H15.3V12.4C15.3 12.1791 15.4791 12 15.7 12H16.9C17.121 12 17.3 12.1791 17.3 12.4ZM12.6 14.6001C12.6 14.3791 12.7791 14.2001 13 14.2001H19.4C19.6209 14.2001 19.8 14.3791 19.8 14.6001V15.2H12.6V14.6001ZM15.7 16.4V17C15.7 17.3314 15.9686 17.6 16.3 17.6C16.6314 17.6 16.9 17.3314 16.9 17V16.4H19.8V19.4C19.8 19.621 19.6209 19.8 19.4 19.8H13C12.7791 19.8 12.6 19.621 12.6 19.4V16.4H15.7Z"
				fill="#4C4C58"
			/>
			<path
				d="M2.96252 13.1251C2.96252 10.5965 5.01703 8.7 7.50002 8.7C9.31176 8.7 10.8955 9.70642 11.621 11.244C11.7624 11.5437 11.6341 11.9013 11.3344 12.0427C11.0347 12.1841 10.6771 12.0557 10.5357 11.7561C10.015 10.6523 8.86289 9.90007 7.50002 9.90007C5.63377 9.90007 4.16252 11.3044 4.16252 13.1251V14.2126H5.25002C5.55812 14.2126 5.81615 14.4459 5.84701 14.7525L6.35515 19.8001H8.64489L9.15304 14.7525C9.18623 14.4228 9.48042 14.1824 9.81012 14.2156C10.1398 14.2488 10.3802 14.543 10.347 14.8727L9.78451 20.4602C9.75365 20.7667 9.49562 21.0001 9.18752 21.0001H5.81252C5.50443 21.0001 5.2464 20.7667 5.21554 20.4602L4.70739 15.4126H3.56252C3.23115 15.4126 2.96252 15.1439 2.96252 14.8126V13.1251Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

ClientIcon.propTypes = iconPropTypes;
ClientIcon.defaultProps = iconDefaultProps;
